module.exports = __webpack_public_path__ + "img/mb_hm_block02_sc.9bd24561.jpg";